/* eslint-disable no-invalid-this */
class ArticleListService {

    constructor() {
        this.EVENTS = {
            PAGINATION: 'PAGINATION',
            RESULTS: 'RESULTS'
        };
        this.listeners = {};
    }

    /**
     *
     * @param {*} cb
     */
    on(event, cb) {

        if (!this.EVENTS[event]) {
            throw new Error('Invalid event name ' + event);
        }

        this.listeners[event] = this.listeners[event] || [];

        if (this.listeners[event].indexOf(cb) === -1) {
            this.listeners[event].push(cb);
        }

        return function () {
            this.listeners[event] = this.listeners[name].filter((item) => item !== cb);
        };
    }

    /**
     *
     */
    emit(event, params) {
        if (!this.EVENTS[event]) {
            throw new Error('Invalid event name ' + event);
        }

        this.listeners[event].map((cb) => cb(params));
    }
}

export default new ArticleListService();


// WEBPACK FOOTER //
// /src/pages/main/articleList.js